import { IPoint, Point } from "./Point.js";

export class Geom {
    /**
     * Cals the distance in kilometres.
     * @psee https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
     */
    public static distanceLatLng(lat1: number, lon1: number, lat2: number, lon2: number): number {
        var R = 6371; // Radius of the earth in km
        var dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
        var dLon = this.deg2rad(lon2 - lon1);
        var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return d;
    }

    public static deg2rad(deg: number): number {
        return deg * (Math.PI / 180)
    }

    public static latLngToTexture(lat: number, lon: number, textureWidth: number, textureHeight: number): IPoint {
        return new Point(((lon + 180) * (textureWidth / 360)) % textureWidth,
            (((lat * -1) + 90) * (textureHeight / 180)) % textureHeight);
    }

    public static textureToLatLng(pointX: number, pointY: number, textureWidth: number, textureHeight: number): IPoint {


        var m = (pointX / textureWidth) * 180 / Math.PI;

        //            console.log(m * 1.7639164489511259);
        //            
        //            pointX /= 600;
        //            pointY /= 600;
        //            
        pointX *= 6378137;
        //            pointY *= 6378137;

        pointX = pointX / textureWidth;
        pointY = pointY / textureHeight;
        var lat = 2 * Math.atan(Math.pow(Math.E, pointY)) - .5 * Math.PI;
        var lon = pointX;
        lat = lat * 180 / Math.PI;
        lon = lon * 180 / Math.PI;
        //            console.log(lat, lon);
        return new Point(lat, lon);

        //            var lng = (pointX) / textureWidth;
        //            var latRadians = (pointY) / - textureHeight;
        //            var lat = ((2 * Math.atan(Math.exp(latRadians)) * Math.PI / 180) - Math.PI / 2);
        //            return new math.Point(lat, lng);
    }

    //SOURCE (modified): http://stackoverflow.com/questions/8935117/how-can-i-convert-curveto-to-a-list-of-points
    public static interpolateQuadraticCurve(u: number, originX: number, originY: number, cpx: number, cpy: number, x: number, y: number): { x: number; y: number } {
        var B1 = (1 - u) * (1 - u);
        var B2 = 2 * u * (1 - u);
        var B3 = u * u;
        var x = originX * B1 + cpx * B2 + x * B3;
        var y = originY * B1 + cpy * B2 + y * B3;
        return { x: x, y: y };
    }

    public static sizePolygon(poly: { x: number; y: number }[]): number {
        var area = 0.0;
        var l = poly.length - 1;
        for (var k = 0; k < l; k++) {
            var xDiff = poly[k + 1].x - poly[k].x;
            var yDiff = poly[k + 1].y - poly[k].y;
            area = area + poly[k].x * yDiff - poly[k].y * xDiff;
        }
        return 0.5 * area;
    }
}